module.exports = __webpack_public_path__ + "static/media/exp.d4c0629b.svg";